module.exports = __webpack_public_path__ + "img/mercury.af931d41.png";